import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

export default function PageLoading() {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: 99999999 }}
      open
    >
      <CircularProgress
        color="primary"
        size={60}
      />
    </Backdrop>
  );
}
